import type { Maybe } from '@adornis/base/utilTypes.js';

/**
 * The address forms store street and house number as one line, edoo.sys wants them apart. The house number is
 * the trailing number with an optional letter and range ("12a", "5 - 7"), so street names containing numbers
 * ("Straße des 17. Juni 12") keep them. A number glued to an abbreviated street ("Goethestr.6") still counts.
 */
export function splitStreetAndNumber(streetAndNumber: Maybe<string>): [street: string, houseNumber: string] {
  const line = streetAndNumber?.trim() ?? '';
  const match = line.match(/^(.+?)(?:\s+|(?<=\.))(\d+\s*[a-zA-Z]?(?:\s*[-/]\s*\d+\s*[a-zA-Z]?)?)$/);
  return match ? [match[1] ?? line, match[2] ?? ''] : [line, ''];
}
